
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { PremiumAddAccountForm } from './PremiumAddAccountForm';

interface CompletePremiumAddAccountDialogProps {
  isOpen: boolean;
  onClose: () => void;
  botId: string;
  onSuccess: () => void;
}

export const CompletePremiumAddAccountDialog = ({ 
  isOpen, 
  onClose, 
  botId,
  onSuccess 
}: CompletePremiumAddAccountDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add New Account</DialogTitle>
        </DialogHeader>
        <PremiumAddAccountForm
          botId={botId}
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
